var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityValue } from '../entities/entity-value';
import { includes } from 'lodash';
var cls = classNames('data-grid-cell-linked-multiple');
export var FieldCellLinkedMultipleDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var ValueStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n  "], ["\n    user-select: none;\n    h2 {\n      white-space: nowrap;\n    }\n\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  NAME: 'FieldCellLinkedMultiple',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Value: styled(EntityValue)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
export var FieldCellLinkedMultiple = function (props) {
  var componentProps = useComponentProps(My.NAME, FieldCellLinkedMultipleDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    value = componentProps.value,
    field = componentProps.field,
    rest = __rest(componentProps, ["className", "children", "value", "field"]);
  var isLogo = includes(['Organisation'], field.entityTypeName);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, value.map(function (item) {
    return React.createElement(My.Value, {
      showImageBorder: isLogo,
      imageStyle: isLogo ? 'logo' : 'default',
      variant: 'card',
      entity: item
    });
  }));
};
FieldCellLinkedMultiple.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;